import React, { useState, useEffect } from 'react';
import './TermsAndConditionsPage.css';

const TermsAndConditionsPage = () => {
  const [currentSection, setCurrentSection] = useState('general');

  // Scroll al top cuando se monta el componente
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const sections = [
    { id: 'general', title: 'Disposiciones Generales', icon: 'fas fa-gavel' },
    { id: 'services', title: 'Servicios y Productos', icon: 'fas fa-cogs' },
    { id: 'accounts', title: 'Cuentas de Usuario', icon: 'fas fa-user-shield' },
    { id: 'privacy', title: 'Privacidad y Datos', icon: 'fas fa-shield-alt' },
    { id: 'intellectual', title: 'Propiedad Intelectual', icon: 'fas fa-copyright' },
    { id: 'liability', title: 'Responsabilidades', icon: 'fas fa-balance-scale' },
    { id: 'turismo', title: 'Turismo', icon: 'fas fa-plane' },
    { id: 'disputes', title: 'Resolución de Disputas', icon: 'fas fa-handshake' }
  ];

  const renderSectionContent = (sectionId) => {
    switch (sectionId) {
      case 'general':
        return (
          <div className="terms-section-content">
            <h3>1. Disposiciones Generales</h3>
            
            <h4>1.1 Objeto y Alcance</h4>
            <p>Los presentes Términos y Condiciones regulan el uso de la tienda virtual Javiland, incluyendo todos los servicios, productos y funcionalidades disponibles a través de nuestra plataforma web en línea.</p>
            
            <h4>1.2 Aceptación de Términos</h4>
            <p>Al acceder y utilizar nuestra tienda virtual, usted acepta estar sujeto a estos términos. Si no está de acuerdo con alguna disposición, le recomendamos no utilizar nuestros servicios.</p>
            
            <h4>1.3 Modificaciones</h4>
            <p>Javiland se reserva el derecho de modificar estos términos en cualquier momento. Las modificaciones entrarán en vigor inmediatamente después de su publicación en la plataforma.</p>
            
            <h4>1.4 Legislación Aplicable</h4>
            <p>Estos términos se rigen por la legislación colombiana aplicable en Bogotá, Colombia, y cualquier disputa será resuelta en los tribunales competentes de Bogotá, Colombia.</p>
          </div>
        );

      case 'services':
        return (
          <div className="terms-section-content">
            <h3>2. Servicios y Productos</h3>
            
            <h4>2.1 Descripción del ecosistema</h4>
            <p>Javiland es un ecosistema digital que integra, entre otros:</p>
            <ul>
              <li><strong>Tienda en línea:</strong> productos naturales, bienestar y artículos seleccionados, con envíos dentro de Colombia. Algunos ítems se gestionan bajo pedido (dropshipping) con plazos indicados en la ficha del producto.</li>
              <li><strong>Servicios de bienestar:</strong> yoga 1 a 1, entrenamiento consciente y el programa Conecta tu camino (psicología y coaching online), con reserva y condiciones publicadas en cada servicio.</li>
              <li><strong>Experiencias Conoce Colombia:</strong> ecoturismo y viajes con información, cotización y condiciones propias de turismo.</li>
              <li><strong>Growth Partner:</strong> acompañamiento a marcas en ecosistemas digitales, sujeto a propuesta comercial aparte.</li>
              <li><strong>Comunidad Javiland:</strong> registro de miembros, contenidos y comunicaciones según la Política de Privacidad.</li>
            </ul>

            <h4>2.2 Pagos en la tienda</h4>
            <p>Los pagos de productos en línea se procesan a través de <strong>Wompi</strong> (pasarela certificada en Colombia). Al completar el checkout usted acepta los montos mostrados (productos, envío e impuestos aplicables). Las transacciones quedan registradas en nuestros sistemas para facturación y soporte.</p>
            
            <h4>2.3 Disponibilidad</h4>
            <p>Nos esforzamos por mantener nuestros servicios disponibles 24/7, pero no garantizamos la disponibilidad ininterrumpida debido a mantenimiento técnico o circunstancias fuera de nuestro control.</p>
            
            <h4>2.4 Calidad de Servicios</h4>
            <p>Javiland se compromete a proporcionar servicios de alta calidad, pero no garantiza que los servicios sean libres de errores o que cumplan con expectativas específicas del usuario.</p>
          </div>
        );

      case 'accounts':
        return (
          <div className="terms-section-content">
            <h3>3. Cuentas de Usuario</h3>
            
            <h4>3.1 Registro y Verificación</h4>
            <p>Para acceder a ciertos servicios, debe crear una cuenta proporcionando información veraz y actualizada. Su cuenta es personal e intransferible.</p>
            
            <h4>3.2 Responsabilidades de la Cuenta</h4>
            <p>Usted es responsable de:</p>
            <ul>
              <li>Mantener la confidencialidad de sus credenciales de acceso</li>
              <li>Todas las actividades realizadas desde su cuenta</li>
              <li>Notificar inmediatamente cualquier uso no autorizado</li>
              <li>Mantener su información de contacto actualizada</li>
            </ul>
            
            <h4>3.3 Suspensión y Cancelación</h4>
            <p>Javiland puede suspender o cancelar su cuenta por violación de estos términos, comportamiento fraudulento o por razones de seguridad.</p>
          </div>
        );

      case 'privacy':
        return (
          <div className="terms-section-content">
            <h3>4. Privacidad y Protección de Datos</h3>
            
            <h4>4.1 Recopilación de Información</h4>
            <p>Recopilamos información personal necesaria para proporcionar nuestros servicios, incluyendo nombre, email, intereses y preferencias.</p>
            
            <h4>4.2 Uso de la Información</h4>
            <p>Su información personal se utiliza para:</p>
            <ul>
              <li>Proporcionar y mejorar nuestros servicios</li>
              <li>Comunicarnos con usted sobre su cuenta</li>
              <li>Enviar información relevante sobre nuestros servicios</li>
              <li>Cumplir con obligaciones legales</li>
            </ul>
            
            <h4>4.3 Seguridad de Datos</h4>
            <p>Implementamos medidas de seguridad técnicas y organizativas para proteger su información personal contra acceso no autorizado, alteración o destrucción.</p>
            
            <h4>4.4 Derechos del Usuario</h4>
            <p>Usted tiene derecho a acceder, rectificar, cancelar y oponerse al tratamiento de sus datos personales, conforme a la legislación colombiana.</p>
          </div>
        );

      case 'intellectual':
        return (
          <div className="terms-section-content">
            <h3>5. Propiedad Intelectual</h3>
            
            <h4>5.1 Derechos de Javiland</h4>
            <p>Todos los contenidos, marcas comerciales, logos, diseños, software y otros elementos de la plataforma son propiedad exclusiva de Javiland o sus licenciantes.</p>
            
            <h4>5.2 Uso Autorizado</h4>
            <p>Se le otorga una licencia limitada, no exclusiva y revocable para utilizar nuestros servicios únicamente para fines personales o comerciales legítimos.</p>
            
            <h4>5.3 Restricciones</h4>
            <p>Está prohibido:</p>
            <ul>
              <li>Copiar, reproducir o distribuir contenido sin autorización</li>
              <li>Modificar, adaptar o crear obras derivadas</li>
              <li>Utilizar contenido para fines comerciales no autorizados</li>
              <li>Eliminar o alterar avisos de propiedad intelectual</li>
            </ul>
          </div>
        );

      case 'liability':
        return (
          <div className="terms-section-content">
            <h3>6. Responsabilidades y Limitaciones</h3>
            
            <h4>6.1 Limitación de Responsabilidad</h4>
            <p>En ningún caso Javiland será responsable por daños indirectos, incidentales, especiales o consecuentes, incluyendo pérdida de beneficios o datos.</p>
            
            <h4>6.2 Responsabilidad del Usuario</h4>
            <p>Usted es responsable de:</p>
            <ul>
              <li>El uso adecuado de nuestros servicios</li>
              <li>Respetar los derechos de otros usuarios</li>
              <li>No realizar actividades ilegales o fraudulentas</li>
              <li>Mantener la integridad de la plataforma</li>
            </ul>
            
            <h4>6.3 Indemnización</h4>
            <p>Usted se compromete a indemnizar y eximir de responsabilidad a Javiland por cualquier reclamación, daño o gasto derivado de su uso de los servicios.</p>
          </div>
        );

      case 'turismo':
        return (
          <div className="terms-section-content">
            <h3>7. Turismo – Servicios Conoce Colombia</h3>
            <p>Los siguientes términos y condiciones aplican específicamente a la utilización de los servicios de turismo y experiencias de ecoturismo comunitario ofrecidos por Javiland a través de la sección Conoce Colombia.</p>

            <h4>7.1 Condiciones Generales</h4>
            <h5>7.1.1 Organización</h5>
            <p>Javiland opera como plataforma que ofrece experiencias de ecoturismo comunitario en Colombia. Su centro de distribución y domicilio operativo de la tienda está en Chía, Cundinamarca. Los servicios turísticos se rigen por la Ley 300 de 1996 y su Decreto Reglamentario 2590 de 2009, el Decreto 502 de 1997 emitido por el Ministerio de Comercio, Industria y Turismo, el Decreto 2438 de 2010, la Ley 1480 de 2011, el Decreto 1074 de 2015 y demás normativas complementarias aplicables al turismo en Colombia.</p>

            <h5>7.1.2 Responsabilidad en la intermediación</h5>
            <p>Los usuarios que adquieran los servicios turísticos ofrecidos en Conoce Colombia son responsables de leer y comprender estas disposiciones. Si no están de acuerdo con alguna de ellas, absténgase de adquirir los servicios ofertados.</p>
            <p>Javiland actúa como agente intermediario entre los usuarios (clientes) y los proveedores de servicios de transporte, alojamiento, alimentación y actividades con comunidades locales. Javiland se compromete a cumplir con los servicios de intermediación y a estructurar experiencias de ecoturismo comunitario. En su calidad de intermediario, Javiland no será responsable de la prestación directa de los servicios de los proveedores turísticos, ni tendrá injerencia en sus decisiones o políticas. No se responsabiliza por el incumplimiento de los prestadores de servicios, ni por imprevistos derivados de eventos de fuerza mayor (huelgas, atrasos de aerolíneas o servicios terrestres, fenómenos naturales, emergencias sanitarias, entre otros). Tampoco por pérdida, daño o hurto de equipaje, accidentes, enfermedades o fallecimientos. Los usuarios deberán realizar los procesos de reclamación directamente ante las empresas prestadoras del servicio incumplido, con la colaboración de Javiland en lo que sea posible.</p>
            <p>Javiland no asume responsabilidad por la prestación del servicio de transporte aéreo o terrestre, incluyendo retrasos o modificaciones imprevistas. Los derechos del usuario y los procedimientos para devoluciones se rigen por lo dispuesto en el Reglamento Aeronáutico Colombiano (RAC 3) cuando aplique, y por las políticas de cada proveedor.</p>
            <p>Javiland informará oportunamente sobre los requisitos de documentación y sanidad necesarios para el ingreso al lugar de destino. Sin embargo, es responsabilidad exclusiva del usuario cumplir con estos requisitos, incluyendo vacunaciones necesarias.</p>

            <h4>7.2 Condiciones de venta de los servicios turísticos</h4>
            <ul>
              <li><strong>7.2.1</strong> Los precios y tarifas publicados o enviados por cotización están sujetos a cambios, disponibilidad y vigencia sin previo aviso. La tarifa confirmada al momento de efectuar la compra o reserva no variará y será garantizada. Los impuestos, tasas y contribuciones pueden variar por disposición del Gobierno Nacional y deben ser asumidos por el usuario.</li>
              <li><strong>7.2.2</strong> En caso de fuerza mayor o caso fortuito antes o durante el viaje, el operador y/o Javiland podrán modificar, reemplazar o cancelar itinerarios, fechas, vuelos, hoteles y servicios turísticos. El pasajero acepta estas condiciones al adquirir los servicios.</li>
              <li><strong>7.2.3</strong> Los reembolsos, en caso de ser aplicables, se realizarán dentro de los 30 días calendario siguientes a la solicitud. El porcentaje de reembolso estará sujeto a las condiciones del proveedor, gastos de administración y cargos por cancelación.</li>
              <li><strong>7.2.4</strong> Las cotizaciones u ofertas generadas mostrarán disponibilidad y valores en el momento de su emisión, pero no implican la confirmación de cupos. La reconfirmación estará sujeta al pago total o al acuerdo de reserva.</li>
              <li><strong>7.2.5</strong> Las tarifas no incluyen llamadas telefónicas a larga distancia, servicio de lavandería, asistencia médica, medicamentos y otros cargos no especificados en el plan.</li>
              <li><strong>7.2.6</strong> En destinos donde exista impuesto al turismo, el pasajero deberá pagar en el aeropuerto o punto correspondiente el valor de la tarjeta de turismo o impuesto equivalente.</li>
              <li><strong>7.2.7</strong> El peso máximo del equipaje permitido está sujeto a las condiciones de cada aerolínea o transportador.</li>
              <li><strong>7.2.8</strong> No se reembolsa saldo de planes utilizados parcialmente, excepto por fuerza mayor o caso fortuito debidamente comprobado.</li>
              <li><strong>7.2.9</strong> Los menores de edad que viajen sin la compañía de sus padres deberán presentar autorización, copia del registro civil, identificación de los padres y de la persona autorizada. Sin estos documentos, no se permitirá el ingreso.</li>
              <li><strong>7.2.10</strong> Todos los viajeros deben tener en regla la documentación personal correspondiente. Las multas o gastos por el no cumplimiento corren por cuenta del pasajero.</li>
              <li><strong>7.2.11</strong> Javiland se reserva el derecho de retirar de las actividades y suspender los servicios a quien atente contra la normalidad o el éxito del servicio.</li>
              <li><strong>7.2.12</strong> Cuando uno o varios servicios no puedan ser ofrecidos por circunstancias atribuibles al proveedor, se podrá ofrecer otro servicio de igual calidad o la opción de reembolsar o compensar el precio pactado.</li>
            </ul>

            <h4>7.3 Retracto y desistimiento</h4>
            <p>El ejercicio de los derechos de retracto y desistimiento se rige por la Resolución 1375 de 2015 – RAC 3 (cuando aplique a transporte aéreo) y la Ley 1480 de 2011. Cualquier servicio que el usuario opte por dejar de utilizar por decisión personal una vez iniciado el viaje no será reembolsable. Los reembolsos se efectuarán dentro de los 30 días calendario siguientes a la solicitud, de acuerdo con las políticas establecidas por cada proveedor. En caso de demoras ajenas a Javiland, no se reconocerán intereses sobre las sumas a reembolsar.</p>

            <h4>7.4 Calidad del servicio</h4>
            <p>Javiland, en calidad de agente intermediario, se compromete a garantizar la óptima prestación de servicios operados por terceros, de acuerdo con lo ofrecido y contratado. Proporcionaremos a nuestros usuarios toda la colaboración y gestión necesaria para transmitir a los proveedores cualquier solicitud, queja o reclamo. Sin embargo, en caso de experimentar alguna dificultad durante la prestación del servicio, el usuario debe comunicarse directa e inmediatamente con el proveedor para resolver la situación de manera expedita, sin perjuicio de informar a Javiland.</p>

            <h4>7.5 Prevención del turismo sexual</h4>
            <p>Conforme al artículo 16 y subsiguientes de la Ley 679 de 2001, Javiland informa a todos los usuarios sobre nuestro compromiso en la prevención, bloqueo, combate y denuncia de cualquier forma de explotación, pornografía o turismo sexual con menores de edad. La explotación y el abuso sexual de menores son delitos penales y sujetos a sanciones administrativas. Instamos a todos los usuarios a respetar y cumplir estrictamente con estas disposiciones legales.</p>

            <h4>7.6 Aceptación</h4>
            <p>El usuario manifiesta de manera expresa, libre y voluntaria haber leído íntegramente estos términos y condiciones de turismo, comprendiendo su naturaleza y alcance. Al adquirir servicios de Conoce Colombia, acepta en su totalidad el contenido de esta sección, el cual complementa los Términos y Condiciones generales de Javiland.</p>
          </div>
        );

      case 'disputes':
        return (
          <div className="terms-section-content">
            <h3>8. Resolución de Disputas</h3>
            
            <h4>8.1 Resolución Amistosa</h4>
            <p>Antes de iniciar cualquier procedimiento legal, las partes se comprometen a intentar resolver sus diferencias de manera amistosa a través de comunicación directa por email a support@javiland.com.</p>
            
            <h4>8.2 Jurisdicción</h4>
            <p>Cualquier disputa será resuelta en los tribunales competentes de Bogotá, Colombia, aplicándose la legislación colombiana vigente.</p>
            
            <h4>8.3 Ley Aplicable</h4>
            <p>Estos términos se rigen por las leyes de Colombia aplicables en Bogotá, sin considerar conflictos de leyes.</p>
            
            <h4>8.4 Separabilidad</h4>
            <p>Si alguna disposición de estos términos es declarada inválida, las demás disposiciones permanecerán en pleno vigor y efecto.</p>
          </div>
        );

      default:
        return null;
    }
  };

  return (
    <div className="terms-page">
      <div className="terms-container">
        <div className="terms-header">
          <button 
            className="back-button"
            onClick={() => {
              window.history.pushState({}, '', '/');
              window.dispatchEvent(new PopStateEvent('popstate'));
            }}
          >
            <i className="fas fa-arrow-left"></i>
            Volver al Inicio
          </button>
          <div className="terms-logo">
            <img src="/images/Logo_Javiland_Largo.png" alt="Javiland" />
          </div>
          <h1>Términos y Condiciones</h1>
          <p className="terms-subtitle">Última actualización: {new Date().toLocaleDateString('es-CO')}</p>
        </div>

        <div className="terms-body">
          <div className="terms-sidebar">
            <nav className="terms-navigation">
              {sections.map((section) => (
                <button
                  key={section.id}
                  className={`terms-nav-item ${currentSection === section.id ? 'active' : ''}`}
                  onClick={() => setCurrentSection(section.id)}
                >
                  <i className={section.icon}></i>
                  <span>{section.title}</span>
                </button>
              ))}
            </nav>
          </div>

          <div className="terms-content">
            <div className="terms-scrollable">
              {renderSectionContent(currentSection)}
              
              <div className="terms-footer">
                <h4>Contacto para Consultas</h4>
                <p>Si tiene preguntas sobre estos términos, contáctenos en:</p>
                <ul>
                  <li><i className="fas fa-envelope"></i> support@javiland.com</li>
                  <li><i className="fas fa-store"></i> Tienda Virtual - Operamos desde Bogotá, Colombia</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsAndConditionsPage;
